import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { LocalStorage } from 'ngx-store';

import { Url } from '../model/users.model';
@Injectable({
  providedIn: 'root'
})
export class PrintService {
  @LocalStorage() url: Url;
  public company_logo :string;
  public company_name :string;
  public address :string;
  public tel_no :string;
  public fax :string;
  public email: string;
  public cloud_storage :string;
    
  private headers = new Headers({ 'Content-Type': 'application/json' });
  // Http Headers
  httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json'
      })
  }
  constructor(public http:HttpClient) {
  }
  
  // Error handling
  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
        // Get client-side error
        errorMessage = error.error.message;
    } else {
        // Get server-side error
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }

  
  getBusinessProfile(): Observable<any> { 
    return this.http.get<any>(this.url.rest + '/tms/getBusinessProfile', this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            ) 
  }

  print(elementId: string, title): void {
    let printContents, popupWin;
    printContents = document.getElementById(elementId).innerHTML;
    
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
      <head>
      <title>${title}</title>
      <style>
      @page {
        size: A4;
      }

      table {
        border-collapse: collapse;
        border-spacing: 0;
        width: 100%;
        border: 1px solid #ddd !important;
    }

    th, td {
        text-align: left;
        padding: 16px;
    }


    tr:nth-child(even) {
        background-color: #f2f2f2 !important;
        box-shadow: inset 0 0 0 1000px #f2f2f2;
    }

    .fn {
      float: footnote;
    }

    thead {
      box-shadow: inset 0 0 0 1000px #f2f2f2;
    }
      
        
    </style>
    </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }
    
  printWithHeaderFooter(elementId: string, title): void {
      let printContents, popupWin;
      printContents = document.getElementById(elementId).innerHTML;
      this.cloud_storage = this.url.cloudStorage;

      this.getBusinessProfile().subscribe(data => {
        this.company_logo = this.cloud_storage + '/business_profile/' + data['profile'][9]['string'];
        this.company_name = data['profile'][0]['string'];
        this.address = data['profile'][4]['string'];
        this.tel_no = data['profile'][5]['string'];
        this.fax = data['profile'][7]['string'];
        this.email =data['profile'][2]['string'];

        popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
        popupWin.document.open();
        popupWin.document.write(`
          <html>
          <head>
          <style>
            @page {
              size: A4;
            }

            .header, .header-space,
            .footer, .footer-space {
              height: 50px;
              font-size: 9px;
            }
            .header {
              position: fixed;
              top: 0;
            }
            .footer {
              position: fixed;
              bottom: 0;
            }
          
            table {
              border-collapse: collapse;
              border-spacing: 0;
              width: 100%;
              border: 0px solid #ddd !important;
              font-size: 11px;
            }

            th, td {
                text-align: left;
                padding: 12px;
                font-size: 8px;
            }

            tr:nth-child(even) {
                background-color: #f2f2f2;
                box-shadow: inset 0 0 0 1000px #f2f2f2;
            }
            .fn {
              float: footnote;
            }
            .thead2 {
              box-shadow: inset 0 0 0 1000px #f2f2f2;
              font-size: 8px;
            }
            
              
            img.logo{
                width: 30px;
                height: 30px;
            }

        </style>
        </head>
        <body onload="window.print();window.close()">
            <div class="header">
                <div style="text-align:left;background-color:transparent;"><img src="${this.company_logo}" class="logo"></div>
            </div>

            <div class="footer">
              <div style="font-family: tahoma; color:dark-gray; font-size:5pt; background-color:transparent" align="left"><strong>${this.company_name}</strong> / ${this.address} / ${this.tel_no} / ${this.email}</div>
            </div>
            <title>${title}</title>
            ${printContents}
            </body>
          </html>`
        );
        popupWin.document.close();
    
        });
      }

}
